module.exports = __webpack_public_path__ + "static/media/icon-keep-dry.330e3c79.svg";